import React from "react";

function Expl() {
    if(document.getElementById("explain").style.display === "none")
        document.getElementById("explain").style.display = "block"
    else document.getElementById("explain").style.display ="none"
}

export default function ExplainTest() {
     
    return(
        <div>
            <button onClick={Expl} className="btn btn-outline-secondary">?</button>
            <div id="explain" style={{display: "none"}}>
                <div><i>пункты сортируются по приоритетам на увеличение, а в пределах приоритета - по датам</i></div>
                <div><b>цвета:</b> будущие, <span className="hard">сегодняшние</span>, <span className="near">завтрашние</span>, <span className="lost">прошедшие</span></div>
            </div>
        </div>
    )
}